import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";
import { countByCategory } from "@/lib/videos";

const tones = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-700",
  "bg-primary-50 text-primary-600",
  "bg-accent-50 text-accent-700",
  "bg-secondary-50 text-secondary-700",
];

export default function CategoryStrip() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
      {categories.map((category, index) => (
        <Link
          key={category.id}
          to={`/category/${category.id}`}
          className="group flex cursor-pointer items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3.5 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-200 hover:bg-primary-50/50 md:p-4"
        >
          <span
            className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg md:h-11 md:w-11 ${tones[index % tones.length]}`}
          >
            <i className={`${category.icon} text-xl`}></i>
          </span>
          <span className="min-w-0">
            <span className="block text-sm font-medium text-foreground-900 group-hover:text-primary-700">
              {category.name}
            </span>
            <span className="mt-0.5 block font-label text-[11px] text-foreground-500">
              {countByCategory(category.id)} 条视频
            </span>
          </span>
        </Link>
      ))}
    </div>
  );
}